import { render, staticRenderFns } from "./SKUDetail.vue?vue&type=template&id=d63b83d2&scoped=true"
import script from "./SKUDetail.vue?vue&type=script&lang=js"
export * from "./SKUDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63b83d2",
  null
  
)

export default component.exports